import React from 'react';
import { assetPath, company } from '../../data/companyData';

export default class WorkPerformanceOne extends React.Component {
    componentDidMount() {

        const $ = window.$;
        
        if ($('.dial').length) {
            $('.dial').appear(function () {
              var elm = $(this);
              var perc = elm.attr('value');
              elm.knob({
                'value': 0,
                'min': 0,
                'max': 100,
                'skin': 'tron',
                'readOnly': true,
                'thickness': 0.15,
                'dynamicDraw': true,
                'displayInput': false
              });
              $({
                value: 0
              }).animate({
                value: perc
              }, {
                duration: 2000,
                easing: 'swing',
                progress: function () {
                  elm.val(Math.ceil(this.value)).trigger('change');
                }
              });
              $(this).append(function () {});
            }, {
              accY: 20
            });
        }

        if ($(".count-box").length) {
            $(".count-box").appear(
              function () {
                var $t = $(this),
                  n = $t.find(".count-text").attr("data-stop"),
                  r = parseInt($t.find(".count-text").attr("data-speed"), 10);
        
                if (!$t.hasClass("counted")) {
                  $t.addClass("counted");
                  $({
                    countNum: $t.find(".count-text").text(),
                  }).animate({
                    countNum: n,
                  }, {
                    duration: r,
                    easing: "linear",
                    step: function () {
                      $t.find(".count-text").text(
                        Math.floor(this.countNum)
                      );
                    },
                    complete: function () {
                      $t.find(".count-text").text(this.countNum);
                    },
                  });
                }
              }, {
                accY: 0
              }
            );
        }
          
    }
    render(){
        return (
            <>
                <section className="work-perfomance-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Start Work Perfomance One Content */}
                            <div className="col-xl-7">
                                <div className="work-perfomance-one__content">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6> Work Performance</h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">More than 20 years improving homes and businesses</h2>
                                        <p className="sec-title__text">{company.shortDescription}</p>
                                    </div>
                                    <div className="work-perfomance-one__content-bottom">
                                        <div className="progress-box">
                                            <div className="inner-box">
                                                <div className="graph-outer">
                                                    <input type="text" className="dial" data-fgColor="#C1121F"
                                                        data-bgColor="#ebebeb" data-width="100" data-height="100"
                                                        data-linecap="normal" value="95" />
                                                    <div className="inner-text count-box"><span className="count-text" data-stop="95"
                                                            data-speed="2000"></span><span className="count-Parsent">%</span></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-box">
                                            <h2>Detail-Driven Finishes</h2>
                                            <p>Cabinetry, trim, doors, drywall, painting, roofing, and remodels handled with care from planning through cleanup.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* End Work Perfomance One Content */}
                            </div>

                            {/* Start Work Perfomance One Img */}
                            <div className="col-xl-5">
                                <div className="work-perfomance-one__img">
                                    <img src={assetPath("gallery-05-built-in-cabinetry.jpeg")} alt="Built-in cabinetry by FA Interior Trim LLC" />
                                </div>
                            </div>
                            {/* Start Work Perfomance One Img */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
